import React from 'react';
import { Navigate } from 'react-router-dom';
import { useInstructor } from '@/features/profile/hooks/useInstructor';

/**
 * Smart redirect: instructors go to their review inbox (/my-roll-reviews),
 * practitioners go to their submission list (/my-reviews).
 *
 * This replaces the old proof-of-concept page that mixed both roles and
 * exposed a generic upload form bypassing the instructor selection flow.
 */
const VideoReview: React.FC = () => {
  const { isInstructor, isLoading } = useInstructor();

  // Wait for role resolution before redirecting so we don't flash the wrong page.
  if (isLoading) return null;

  return <Navigate to={isInstructor ? '/my-roll-reviews' : '/my-reviews'} replace />;
};

export default VideoReview;
